import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams, Link } from 'react-router-dom';
import './ArtistAccounts.css';
import './ArtistInvitePolish.css';

export default function ArtistInvite() {
  const { token } = useParams();
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [message, setMessage] = useState('');
  const [email, setEmail] = useState('');
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [status, setStatus] = useState('checking');
  const [copied, setCopied] = useState(false);
  useEffect(() => {
    let cancelled = false;
    setStatus('checking');
    axios.get(`/api/auth/artist-invite-status/${encodeURIComponent(token || '')}`)
      .then(() => { if (!cancelled) setStatus('valid'); })
      .catch(e => { if (!cancelled) setStatus(e.response?.status === 410 ? 'expired' : 'error'); });
    return () => { cancelled = true; };
  }, [token]);
  async function copyLoginEmail() {
    try {
      await navigator.clipboard.writeText(email);
      setCopied(true);
    } catch (_) {
      setCopied(false);
      setMessage('Copy was unavailable. Please select the email above.');
    }
  }
  async function submit(e) {
    e.preventDefault();
    if (status !== 'valid') return;
    if (password !== confirm) { setMessage('Passwords do not match.'); return; }
    setBusy(true); setMessage('');
    try {
      const { data } = await axios.post('/api/auth/accept-artist-invite', { token, password });
      setEmail(data.email || ''); setDone(true); setPassword(''); setConfirm('');
    } catch (e) { if (e.response?.status === 410) { setStatus('expired'); setPassword(''); setConfirm(''); } else setMessage('Unable to activate your account. Please try again.'); }
    finally { setBusy(false); }
  }
  return <main className="aa-invite-page"><section className="aa-panel aa-invite-card">
    <div className="aa-invite-brand"><span>AEONAS OS <small>PRIME INK ARTIST</small></span></div>
    {status === 'checking' ? <p className="aa-invite-loading">Checking your invitation…</p> : status === 'expired' ? <div className="aa-invite-state">
      <div className="aa-invite-symbol" aria-hidden="true">✕</div>
      <span className="aa-invite-eyebrow">ACCOUNT INVITATION</span>
      <h1>Invitation link expired</h1>
      <p>This link has already been used or is no longer valid.</p>
      <p className="aa-invite-muted">Already activated your account? Sign in with your email and password. Otherwise, ask Prime Ink for a new invitation.</p>
      <Link className="aa-invite-cta" to="/login">Go to Login <span aria-hidden="true">→</span></Link>
    </div> : status === 'error' ? <>
      <h1>Unable to verify invitation</h1><p>We couldn't verify this invitation right now. Please try again later.</p>
      <button type="button" onClick={() => window.location.reload()}>Try again</button>
    </> : done ? <>
      <h1>You're all set</h1><p>Your artist account is ready. Two quick steps to get started.</p>
      <div className="aa-invite-steps">
        <section className="aa-invite-step" aria-label="Step 1: Copy login email">
          <div className="aa-invite-step-heading"><span className="aa-invite-step-number">01</span><span>Copy your login email</span></div>
          {email && <><p className="aa-invite-email-value">{email}</p><button className="aa-invite-copy-button" type="button" onClick={copyLoginEmail}>{copied ? 'Copied ✓' : 'Copy login email'}</button></>}
        </section>
        <section className="aa-invite-step" aria-label="Step 2: Proceed to login">
          <div className="aa-invite-step-heading"><span className="aa-invite-step-number">02</span><span>Sign in to your artist account</span></div>
          <Link className="aa-invite-dashboard-button" to={email ? `/login?email=${encodeURIComponent(email)}` : '/login'}><span>Proceed to Login</span><span className="aa-invite-dashboard-arrow" aria-hidden="true">→</span></Link>
        </section>
      </div>
      {message && <p role="alert">{message}</p>}
    </> : <form onSubmit={submit}>
      <h1>Set up your Artist Access</h1><p>Create your personal password to access your AEONAS OS artist account. This invitation can only be used once.</p>
      <label>Password<input type={showPassword ? 'text' : 'password'} autoComplete="new-password" required minLength={12} maxLength={128} value={password} onChange={e => setPassword(e.target.value)}/></label>
      <label>Confirm password<input type={showPassword ? 'text' : 'password'} autoComplete="new-password" required minLength={12} maxLength={128} value={confirm} onChange={e => setConfirm(e.target.value)}/></label>
      <button type="button" onClick={() => setShowPassword(v => !v)}><span aria-hidden="true" style={{marginRight:8}}>◉</span>{showPassword ? 'Hide passwords' : 'Show passwords'}</button>
      {message && <p role="alert">{message}</p>}
      <button className="aa-primary" disabled={busy} type="submit">{busy ? 'Activating…' : 'Activate My Account'} <span aria-hidden="true" style={{fontSize:19,fontWeight:400,marginLeft:12}}>→</span></button>
    </form>}
  </section></main>;
}
